import React from 'react';
import Logo from '../assets/26.png';
import QRCode from '../assets/25.png';
import Signature from '../assets/27.png';
import html2pdf from 'html2pdf.js';

const InvoiceSale = ({ data, settings, onClose, onSave }) => {
  const taxP = Number(data?.taxPercent || 18);
  const taxableVal = Number(data?.taxableAmount || data?.netPayable || 0);
  const calculatedTotalTax = data?.totalTax && data.totalTax > 0 ? Number(data.totalTax) : taxableVal * (taxP / 100);
  const cgstVal = calculatedTotalTax / 2;
  const sgstVal = calculatedTotalTax / 2;
  const finalTotalAmount = data?.totalTax && data.totalTax > 0 ? Number(data?.netPayable || 0) : Math.round(taxableVal + calculatedTotalTax);

  const numberToWords = (num) => {
    const a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
    const b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.trim();
  };

  // Map form data to the invoice template format
  const invoice = {
    invoiceNo: data?.invoiceNo || "-",
    customerName: data?.customer || "-",
    shippingCustomerName: data?.deliveryContactPerson || data?.customer || "-",
    contactNoRef: `${data?.customerPhone || ""} ${data?.reference ? `- ${data.reference}` : ""}`.trim() || "-",
    fullAddress: [data?.billingAddressLine1, data?.billingAddressLine2, data?.billingCity, data?.billingState, data?.billingPincode].filter(Boolean).join(', ') || "ainapuram, mummidivaram, amalapuram, east godavari, 533216",
    placeOfSupply: data?.billingCity || "amalapuram",
    shippingAddress: [data?.deliveryAddressLine1, data?.deliveryAddressLine2, data?.deliveryCity, data?.deliveryState, data?.deliveryPincode].filter(Boolean).join(', ') || "ainapuram, mummidivaram, amalapuram, east godavari, 533216",
    shippingContact: data?.deliveryPhone || data?.customerPhone || '-',
    shippingPlaceOfSupply: data?.deliveryCity || data?.billingCity || "amalapuram",
    date: data?.saleDate ? new Date(data.saleDate).toLocaleDateString('en-GB') : new Date().toLocaleDateString('en-GB'),
    location: "Vijayawada",
    accountBank: "HDFC Bank",
    accountNumber: "99999989566677",
    ifscCode: "IFSC: HDFC0003975, Enikepadu Branch",
    items: data?.items?.map((i, idx) => ({
      sNo: idx + 1,
      articleId: i.item?.articleId || i.item?.itemCode || "-",
      description: i.item?.description || i.item?.information || i.item?.itemName || "-",
      units: i.unit || "Set",
      qty: i.qty || 1,
      price: Number(i.rate || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      total: (Number(i.qty || 1) * Number(i.rate || 0)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      disPercent: `${Number(i.discountPercent || i.disPercent || i.discP || 0)}%`,
      disAmt: (Number(i.qty || 1) * Number(i.rate || 0) * (Number(i.discountPercent || i.disPercent || i.discP || 0) / 100)).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount: Number(i.amount || ((Number(i.qty || 1) * Number(i.rate || 0)) - (Number(i.qty || 1) * Number(i.rate || 0) * (Number(i.discountPercent || i.disPercent || i.discP || 0) / 100)))).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    })) || [],
    billing: {
      taxableValue: taxableVal,
      cgst: cgstVal,
      sgst: sgstVal,
      totalAmount: finalTotalAmount,
      amountInWords: data?.amountInWords || numberToWords(Math.round(finalTotalAmount)) || ''
    }
  };

  const fmt = (num) => Number(num || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const handleDownload = () => {
    const element = document.getElementById('invoice-pdf-content');
    const opt = {
      margin: 10,
      filename: `Invoice_${data?.invoiceNo || 'Draft'}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().from(element).set(opt).save();
  };

  return (
    <div className="w-full flex flex-col bg-slate-50 border border-slate-200 shadow-sm rounded-xl overflow-hidden mx-auto max-w-4xl">
      <div className="w-full shrink-0 overflow-hidden flex justify-center py-8">
        <div id="invoice-pdf-content" style={{ width: '715px', background: 'white', border: '0.5pt solid #9ca3af', boxSizing: 'border-box', fontFamily: "'Inter', sans-serif", fontSize: '9px', color: '#000', position: 'relative' }}>
          <style>
            {`
              @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
              #invoice-pdf-content { -webkit-print-color-adjust: exact; color: #000 !important; letter-spacing: -0.1px; }
              #invoice-pdf-content * { box-sizing: border-box; }
              
              .label-cell { width: 180px; font-weight: 400; border: none !important; padding: 2px 8px !important; color: #000 !important; font-size: 9px !important; }
              .colon-cell { width: 10px; font-weight: 400; border: none !important; padding: 2px 0 !important; text-align: center; color: #000 !important; font-size: 9px !important; }
              .value-cell { font-weight: 500; border: none !important; padding: 2px 8px !important; color: #000 !important; font-size: 9px !important; }
              
              .header-table { width: 100%; border-collapse: collapse; border: none; }
              .header-table td { border: none !important; padding: 0 !important; }
              
              .section-table, .items-table { width: 100%; border-collapse: collapse; border-top: none; border-left: none; border-right: none; margin: 0; }
              
              .section-table > tbody > tr > td, .section-table > tr > td,
              .items-table > thead > tr > th, .items-table > tbody > tr > td { 
                  border: 0.5pt solid #9ca3af !important; padding: 2px 8px; color: #000 !important; background: #fff !important; font-size: 8px !important;
              }
              .section-table td:first-child { border-left: none !important; }
              .section-table td:last-child { border-right: none !important; }
              .section-table tr:first-child td { border-top: none !important; }
              .items-table th { font-weight: 700; text-align: center; background: #fff !important; border-bottom: 0.5pt solid #9ca3af !important; }
              .text-center { text-align: center; }
              .font-bold { font-weight: 700; }
            `}
          </style>

          {/* 1. HEADER SECTION */}
          <div style={{ padding: '6px 15px', borderBottom: '0.5pt solid #9ca3af' }}>
              <table className="header-table">
                  <tbody>
                      <tr>
                          <td style={{ width: '220px' }}>
                              <img src={settings?.logoUrl || Logo} style={{ width: '155px', height: '50px', objectFit: 'contain' }} alt="Logo" />
                          </td>
                          <td style={{ textAlign: 'left', paddingLeft: '12px', verticalAlign: 'middle' }}>
                              <div style={{ fontSize: '16px', fontWeight: '600', color: '#000', letterSpacing: '-0.2px' }}>{settings?.name || "VNB INDIA PRIVATE LIMITED"}</div>
                              <div style={{ marginTop: '2px', lineHeight: '1.4', fontSize: '11px', fontWeight: '400', color: '#000' }}>
                                  {settings?.address || '1st Floor, Sri Babu Sadan, Plot No 66, CTO Colony, Gurunanak Nagar Vijayawada'}<br/>
                                  Email: {settings?.email || 'accounts@vnb.in'}<br/>
                                  {settings?.phone ? 'PH: ' + settings.phone : 'PH: 8333018333'}
                              </div>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>

          {/* 2. INVOICE TITLE */}
          <div className="text-center font-bold" style={{ padding: '2px 0', fontSize: '12px', borderBottom: '0.5pt solid #9ca3af', letterSpacing: '1px' }}>
              INVOICE
          </div>

          {/* 3. DETAILS SECTION */}
          <table className="section-table" style={{ borderBottom: '0.5pt solid #9ca3af', tableLayout: 'fixed' }}>
              <tbody>
                  <tr>
                      <td style={{ width: '50%', padding: '0 !important' }}>
                          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '6px' }}>
                              <tbody>
                                  <tr>
                                      <td className="label-cell">Invoice No.</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.invoiceNo}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Date</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.date}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td style={{ width: '50%', padding: '0 !important' }}>
                          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '6px' }}>
                              <tbody>
                                  <tr>
                                      <td className="label-cell">State</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{settings?.state || 'Andhra Pradesh'}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">State Code</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{settings?.stateCode || '37'}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                  </tr>
              </tbody>
          </table>

          {/* 4. BILLING & SHIPPING SECTION */}
          <table className="section-table" style={{ borderBottom: '0.5pt solid #9ca3af', tableLayout: 'fixed' }}>
              <tbody>
                  <tr>
                      <td style={{ width: '50%', padding: '0 !important', verticalAlign: 'top' }}>
                          <div style={{ padding: '2px 8px', fontWeight: 'bold', fontStyle: 'italic', fontSize: '9px' }}>Billed to :</div>
                          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '6px' }}>
                              <tbody>
                                  <tr>
                                      <td className="label-cell">Customer Name</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.customerName}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Customer Address</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell" style={{ whiteSpace: 'normal' }}>{invoice.fullAddress}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Customer Mobile No.</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{data?.customerPhone || '—'}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Ref</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{data?.reference || 'architect'}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Place of Supply</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.placeOfSupply}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                      <td style={{ width: '50%', padding: '0 !important', verticalAlign: 'top' }}>
                          <div style={{ padding: '2px 8px', fontWeight: 'bold', fontStyle: 'italic', fontSize: '9px' }}>Shipped to :</div>
                          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '6px' }}>
                              <tbody>
                                  <tr>
                                      <td className="label-cell">Customer Name</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.shippingCustomerName}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Customer Address</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell" style={{ whiteSpace: 'normal' }}>{invoice.shippingAddress}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Customer Mobile No.</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.shippingContact}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Ref</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{data?.reference || 'architect'}</td>
                                  </tr>
                                  <tr>
                                      <td className="label-cell">Place of Supply</td>
                                      <td className="colon-cell">:</td>
                                      <td className="value-cell">{invoice.shippingPlaceOfSupply}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                  </tr>
              </tbody>
          </table>

          {/* 5. ITEMS TABLE (Sale Material Design) */}
          <div className="text-center font-bold" style={{ padding: '4px 8px 6px 8px', fontSize: '11px' }}>
              PROJECT INVENTORY & MATERIALS
          </div>
          <table className="items-table" style={{ tableLayout: 'fixed', width: '100%', borderBottom: '0.5pt solid #9ca3af' }}>
              <thead>
                  <tr>
                      <th style={{ width: '4%' }}>S.no</th>
                      <th style={{ width: '12%' }}>Article Id</th>
                      <th style={{ width: '34%' }}>Article Description</th>
                      <th style={{ width: '6%' }}>Units</th>
                      <th style={{ width: '5%' }}>Qty</th>
                      <th style={{ width: '8%' }}>Price</th>
                      <th style={{ width: '8%' }}>Total</th>
                      <th style={{ width: '6%' }}>Dis%</th>
                      <th style={{ width: '8%' }}>Dis Amt</th>
                      <th style={{ width: '9%' }}>Amount</th>
                  </tr>
              </thead>
              <tbody>
                  {invoice.items.length > 0 ? invoice.items.map((item, idx) => (
                      <tr key={idx}>
                          <td style={{ textAlign: 'center', verticalAlign: 'top', padding: '2px 4px 4px 4px', fontSize: '8.5px' }}>{item.sNo}</td>
                          <td style={{ verticalAlign: 'top', padding: '2px 4px 4px 4px', fontSize: '8.5px', wordBreak: 'break-word' }}>{item.articleId}</td>
                          <td style={{ verticalAlign: 'top', padding: '2px 4px 4px 4px', textAlign: 'left', fontSize: '8.5px', wordBreak: 'break-word' }}>{item.description}</td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.units}</td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.qty}</td>
                          <td style={{ textAlign: 'right', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.price}</td>
                          <td style={{ textAlign: 'right', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.total}</td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.disPercent}</td>
                          <td style={{ textAlign: 'right', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.disAmt}</td>
                          <td style={{ textAlign: 'right', verticalAlign: 'middle', fontSize: '8.5px', paddingBottom: '4px' }}>{item.amount}</td>
                      </tr>
                  )) : (
                      <tr>
                          <td colSpan="10" style={{ textAlign: 'center', padding: '8px', fontSize: '9px' }}>No items added to invoice</td>
                      </tr>
                  )}
              </tbody>
          </table>

          {/* 6. GST SECTION (Like in old template) */}
          <table style={{ width: '100%', borderCollapse: 'collapse', borderBottom: '0.5pt solid #9ca3af' }}>
              <tbody>
                  <tr>
                      <td style={{ width: '50%', border: 'none', padding: '0', verticalAlign: 'top', borderRight: '0.5pt solid #9ca3af' }}>
                          <div style={{ fontSize: '9px', fontWeight: 'bold', padding: '8px' }}>
                              Total Invoice Amount in Words : INR : Rupees {invoice.billing.amountInWords || ''} Only
                          </div>
                      </td>
                      <td style={{ width: '50%', border: 'none', padding: '0', verticalAlign: 'top' }}>
                          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '8px' }}>
                              <tbody>
                                  <tr>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', padding: '3px 8px', fontWeight: 'bold', width: '60%', textAlign: 'right' }}>TOTAL AMOUNT BEFORE TAX</td>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', borderLeft: '0.5pt solid #9ca3af', borderRight: '0.5pt solid #9ca3af', padding: '3px 8px', textAlign: 'right', fontWeight: 'bold', width: '40%' }}>{fmt(invoice.billing.taxableValue)}</td>
                                  </tr>
                                  <tr>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', padding: '3px 8px', fontWeight: 'bold', textAlign: 'right' }}>ADD: CGST ({taxP / 2}%)</td>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', borderLeft: '0.5pt solid #9ca3af', borderRight: '0.5pt solid #9ca3af', padding: '3px 8px', textAlign: 'right', fontWeight: 'bold' }}>{fmt(invoice.billing.cgst)}</td>
                                  </tr>
                                  <tr>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', padding: '3px 8px', fontWeight: 'bold', textAlign: 'right' }}>ADD: SGST ({taxP / 2}%)</td>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', borderLeft: '0.5pt solid #9ca3af', borderRight: '0.5pt solid #9ca3af', padding: '3px 8px', textAlign: 'right', fontWeight: 'bold' }}>{fmt(invoice.billing.sgst)}</td>
                                  </tr>
                                  <tr>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', padding: '3px 8px', fontWeight: 'bold', textAlign: 'right' }}>ADD: IGST</td>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', borderLeft: '0.5pt solid #9ca3af', borderRight: '0.5pt solid #9ca3af', padding: '3px 8px', textAlign: 'right', fontWeight: 'bold' }}>-</td>
                                  </tr>
                                  <tr>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', padding: '3px 8px', fontWeight: 'bold', textAlign: 'right' }}>TAX AMOUNT : GST</td>
                                      <td style={{ borderBottom: '0.5pt solid #9ca3af', borderLeft: '0.5pt solid #9ca3af', borderRight: '0.5pt solid #9ca3af', padding: '3px 8px', textAlign: 'right', fontWeight: 'bold' }}>{fmt(invoice.billing.cgst + invoice.billing.sgst)}</td>
                                  </tr>
                                  <tr style={{ backgroundColor: '#f8fafc' }}>
                                      <td style={{ padding: '4px 8px', fontWeight: 'bold', textAlign: 'right', fontSize: '9px' }}>TOTAL AMOUNT AFTER TAX</td>
                                      <td style={{ borderLeft: '0.5pt solid #9ca3af', borderRight: '0.5pt solid #9ca3af', padding: '4px 8px', textAlign: 'right', fontWeight: 'bold', fontSize: '9px' }}>{fmt(invoice.billing.totalAmount)}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </td>
                  </tr>
              </tbody>
          </table>

          {/* 7. WARRANTY & BANK DETAILS */}
          <table className="section-table" style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                  <tr>
                      <td style={{ width: '75%', padding: '1px 8px 2px 8px !important', fontWeight: '700 !important', borderRight: '0.5pt solid #9ca3af', borderBottom: '0 !important', fontSize: '9px', verticalAlign: 'middle', height: '15px' }}><span style={{ borderBottom: '0.5pt solid #9ca3af', display: 'inline-block', paddingBottom: '2px' }}>Warranty:</span></td>
                      <td style={{ width: '25%', padding: '1px 8px 2px 8px !important', fontWeight: '700 !important', textAlign: 'left', fontSize: '8px !important', whiteSpace: 'normal', verticalAlign: 'middle', borderBottom: '0 !important', height: '15px' }}><span style={{ borderBottom: '0.5pt solid #9ca3af', display: 'inline-block', paddingBottom: '2px' }}>BANK DETAILS FOR PAYMENT</span></td>
                  </tr>
                  <tr>
                      <td style={{ padding: '0 8px !important', verticalAlign: 'top', borderRight: '0.5pt solid #9ca3af', borderTop: '0 !important' }}>
                          <div style={{ fontSize: '9px', lineHeight: '1.2', whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-word', width: '100%' }}>
                              <div>1. Standard manufacturer warranty applies.</div>
                          </div>
                      </td>
                      <td style={{ padding: '0 8px !important', verticalAlign: 'top', borderTop: '0 !important' }}>
                          <div style={{ fontSize: '8px', lineHeight: '1.4', width: '100%', textTransform: 'uppercase' }}>
                              <div style={{ marginBottom: '2px' }}>
                                  <span style={{ display: 'inline-block', width: '70px', fontWeight: '400' }}>BANK NAME</span>
                                  <span style={{ fontWeight: '600' }}>: {data?.bankData?.bankName || settings?.bankName || 'HDFC Bank'}</span>
                              </div>
                              <div style={{ marginBottom: '2px' }}>
                                  <span style={{ display: 'inline-block', width: '70px', fontWeight: '400' }}>A/C No.</span>
                                  <span style={{ fontWeight: '600' }}>: {data?.bankData?.accountNumber || settings?.accountNumber || '99999989566677'}</span>
                              </div>
                              <div style={{ marginBottom: '2px' }}>
                                  <span style={{ display: 'inline-block', width: '70px', fontWeight: '400' }}>IFSC code</span>
                                  <span style={{ fontWeight: '600' }}>: {data?.bankData?.ifscCode || settings?.ifscCode || 'HDFC0003975'}</span>
                              </div>
                              <div style={{ marginBottom: '10px' }}>
                                  <span style={{ display: 'inline-block', width: '70px', fontWeight: '400' }}>BRANCH</span>
                                  <span style={{ fontWeight: '600' }}>: {data?.bankData?.branch || settings?.branch || 'Enikepadu Branch'}</span>
                              </div>
                          </div>
                      </td>
                  </tr>
              </tbody>
          </table>

          {/* 8. TERMS & CONDITIONS & SIGNATORY */}
          <table className="section-table" style={{ tableLayout: 'fixed', width: '100%' }}>
              <tbody>
                  <tr>
                      <td style={{ width: '55%', padding: '1px 8px 2px 8px !important', fontWeight: '700 !important', borderRight: '0.5pt solid #9ca3af', borderBottom: '0 !important', fontSize: '9px', verticalAlign: 'middle', height: '15px' }}><span style={{ borderBottom: '0.5pt solid #9ca3af', display: 'inline-block', paddingBottom: '2px' }}>Terms & Conditions</span></td>
                      <td style={{ width: '45%', padding: '1px 8px 2px 8px !important', fontWeight: '600 !important', fontSize: '9px', borderBottom: '0 !important', textAlign: 'center', verticalAlign: 'middle', height: '15px' }}>For {settings?.name || "VNB INDIA PRIVATE LIMITED"}</td>
                  </tr>
                  <tr>
                      <td style={{ padding: '0 8px !important', verticalAlign: 'top', borderRight: '0.5pt solid #9ca3af', borderBottom: 'none !important', borderTop: '0 !important' }}>
                          <div style={{ fontSize: '9px', lineHeight: '1.2', wordWrap: 'break-word', overflowWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                              <div>1. Standard terms and conditions apply.</div>
                          </div>
                      </td>
                      <td style={{ padding: '0 8px 10px 8px', verticalAlign: 'top', textAlign: 'center', borderBottom: 'none !important', borderTop: '0 !important' }}>
                          <div style={{ marginTop: '2px', marginBottom: '2px', display: 'flex', justifyContent: 'center', minHeight: '30px' }}>
                              <img src={Signature} alt="Signature" style={{ height: '35px', objectFit: 'contain' }} />
                          </div>
                          <div style={{ fontWeight: '600 !important', textAlign: 'center', marginBottom: '25px', fontSize: '9px' }}>Authorized Signature</div>
                      </td>
                  </tr>
              </tbody>
          </table>

        </div>
      </div>
      
      {/* Footer Actions inside the component */}
      <div className="flex gap-3 px-6 py-4 bg-slate-50 border-t border-slate-200 justify-end shrink-0">
        <button 
          onClick={onClose}
          className="px-6 py-2.5 text-sm font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 rounded-xl transition-all shadow-sm"
        >
          Update
        </button>
        <button 
          onClick={async () => {
            if(onSave) {
              const success = await onSave();
              if (success) {
                handleDownload();
              }
            } else {
              handleDownload();
            }
          }}
          className="px-6 py-2.5 text-sm font-bold text-white bg-[#111111] hover:bg-black rounded-xl transition-all shadow-md flex items-center gap-2"
        >
          Save & Download
        </button>
      </div>
    </div>
  );
};

export default InvoiceSale;
